import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import MessageQueueListItemDao from '@/interfaces/admin/MessageQueueListItem.dao'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'

export default class MessageQueuesService extends ApiService {
    async getMessageQueues(
        params?: IRequestParameters,
    ): Promise<[MessageQueueListItemDao[], PageNumberPagination] | null> {
        return this.request<undefined, [MessageQueueListItemDao[], PageNumberPagination] | null>(
            'GET',
            '/message-queues',
            params,
            undefined,
            undefined,
            'getMessageQueues',
        ).catch(() => null)
    }

    async getMessageTypes(): Promise<string[] | null> {
        return this.request<undefined, string[]>(
            'GET',
            '/message-queues/message-types',
            undefined,
            undefined,
            undefined,
            'getMessageTypes',
        ).catch(() => null)
    }
}
